<p-confirmDialog #cd [header]="headers" [message]="menssages" icon="pi pi-exclamation-triangle" [key]="keys">
  <p-footer>
    <button type="button" pButton icon="pi pi-check" label="Sim" (click)="cd.accept()" class="ui-button-danger"></button>
    <button type="button" pButton icon="pi pi-times" label="Não" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>
